import block from './block.json';

export const listThemeAttributes = {
	ol: {
		markerColor: '@tokens.variants.default.titleColor',
		subMarkerColor: '@tokens.variants.default.contentColor',
	},
	ul: {
		markerColor: '@tokens.variants.default.titleColor',
		subMarkerColor: '@tokens.variants.default.contentColor',
	},
	text: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
	},
};

export const ListThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: listThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
